import { render, staticRenderFns } from "./SlideSharedLinkMenu.vue?vue&type=template&id=c997e4ac&scoped=true"
import script from "./SlideSharedLinkMenu.vue?vue&type=script&lang=ts"
export * from "./SlideSharedLinkMenu.vue?vue&type=script&lang=ts"
import style0 from "./SlideSharedLinkMenu.vue?vue&type=style&index=0&id=c997e4ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c997e4ac",
  null
  
)

export default component.exports